import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Icon from "../components/Icon";
import { industries } from "../data/content";

const blurbs = {
  Manufacturing: "Raw material inbound and finished goods distribution, synchronized with production schedules.",
  "Energy & Mining": "Heavy equipment and bulk material movement to remote and hard-to-access sites.",
  "Oil & Gas": "Specialized handling for hazardous and oversized components under strict compliance standards.",
  "Construction & Infrastructure": "Project cargo coordination for structural materials, machinery, and site equipment.",
  Automotive: "Time-critical parts distribution and vehicle logistics across the supply network.",
  "Retail & Consumer Goods": "Warehousing and last-mile distribution built for fast-moving inventory.",
  "Technology & Electronics": "Secure, high-value freight handling with careful customs documentation.",
  "Event & Exhibition Organizers": "Temporary importation and onsite coordination for exhibitions and live events.",
  "Government & Public Sector": "Compliant, transparent logistics execution for public sector programs.",
  "Sports & Entertainment": "Reliable equipment and production logistics for large-scale events.",
};

export default function Industries() {
  return (
    <>
      <Seo path="/industries" />

      <header className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/container-yard-forklift.jpg" alt="Reach stacker moving containers in a container yard" />
        </div>
        <div className="container page-hero__inner">
          <span className="page-hero__crumb">
            <Link to="/">Home</Link> / Industries
          </span>
          <h1>Industries We Serve</h1>
          <p>
            From heavy industry to live events, we tailor logistics solutions to the
            operating realities of every sector we support.
          </p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="industries-grid">
            {industries.map((ind) => (
              <div className="industry-card" key={ind.title}>
                <div className="industry-card__icon">
                  <Icon name={ind.icon} size={22} />
                </div>
                <div>
                  <h3>{ind.title}</h3>
                  <p>{blurbs[ind.title]}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tight section--alt">
        <div className="container">
          <div className="cta-banner cta-banner--dark">
            <h2>Don&rsquo;t see your industry listed?</h2>
            <Link to="/contact" className="btn btn-primary">
              Let&rsquo;s Talk <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
